/** @jsx h */
import { labels } from '../config';
import { useRef, useEffect } from 'preact/hooks';

const Pagination = ({ pagination, triggerLoadMore, pluginNamespace }) => {
  const paginationInputEl = useRef(null);

  useEffect(() => {
    if (paginationInputEl && paginationInputEl.current) {
      paginationInputEl.current.value = '';
    }
  }, []);

  function handleLoadMoreClick() {
    if (paginationInputEl && paginationInputEl.current) {
      paginationInputEl.current.value = pagination.current + 1;
      triggerLoadMore();
    }
  }

  /* Only show load more button, if there is something to load */
  if (
    pagination &&
    (pagination.current === pagination.numberOfPages ||
      pagination.numberOfPages === 0)
  ) {
    return '';
  }

  return (
    <div className="search-list__loadmore">
      <input
        type="text"
        name={`${pluginNamespace}[page]`}
        hidden
        readonly
        ref={paginationInputEl}
      />
      <button
        className="button-animation"
        type="button"
        onClick={handleLoadMoreClick}
      >
        <span>{labels.pagination.loadMore}</span>
      </button>
    </div>
  );
};

export default Pagination;
